import { call, put, takeEvery } from 'redux-saga/effects';
import { targetedCatalogActionCreators, TargetedCatalogActionKeys, UpdateTargetedItemGroup } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateTargetedItemGroup } from '../targetedCatalogApi';
import { ITargetedCatalogGroup } from '../targetedCatalogInterfaces';

function* updateTargetedItemGroupSaga(action: UpdateTargetedItemGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogGroup[]> = yield call(updateTargetedItemGroup, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setItemGroups(response.value));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateTargetedItemGroup() {
  yield takeEvery(TargetedCatalogActionKeys.UPDATE_TARGETED_ITEM_GROUP, updateTargetedItemGroupSaga);
}
